export function Kit() {
  return (
    <section className="bg-alt" id="kit">
      <div className="container">
        <div className="section-head">
          <span className="section-tag">Wat zit er bij</span>
          <h2>Alle componenten zijn inbegrepen</h2>
          <p>
            De pilot-prijs van €30 dekt alles wat je nodig hebt. Elk kind krijgt zijn eigen set
            componenten om mee naar huis te nemen — plus een werkende memory-game.
          </p>
        </div>
        <div className="kit-grid">
          <div className="kit-visual">
            <img src="/assets/sections/elegoo-basic-kit.jpg" alt="Elegoo Basic Starter Kit voor Arduino UNO R3" />
          </div>
          <div className="kit">
            <h3>Inbegrepen in je workshop</h3>
            <p style={{ color: "var(--ink-soft)", marginBottom: 16 }}>
              We leveren de complete Elegoo Basic Starter Kit (t.w.v. €20). Je kind bouwt
              zijn eigen Simon Says game tijdens de sessie en neemt de hele kit werkend
              mee naar huis — inclusief alle onderdelen om thuis verder te experimenteren.
            </p>
            <div className="kit-price-box" style={{ marginBottom: 12 }}>
              <strong>€20</strong>
              <span>Bouwkit waarde — gratis inbegrepen bij eerste workshop</span>
            </div>
            <p style={{ color: "var(--ink-soft)", marginBottom: 20, fontSize: 14 }}>
              <strong style={{ color: "var(--ink)" }}>Herbruikbaar in elke volgende workshop:</strong> de
              kit blijft van je kind. Volgende workshops kosten dan slechts <strong style={{ color: "var(--ink)" }}>€10</strong> (zonder
              nieuwe kit).
            </p>
            <ul className="kit-table">
              <li><span>Arduino UNO R3 board</span><strong>1 stuk</strong></li>
              <li><span>Breadboard 400-point</span><strong>1 stuk</strong></li>
              <li><span>USB-B kabel</span><strong>1 stuk</strong></li>
              <li><span>LEDs (rood/geel/blauw/groen/wit)</span><strong>5 per kleur</strong></li>
              <li><span>Tactile push buttons</span><strong>5 stuks</strong></li>
              <li><span>Passive piezo buzzer</span><strong>1 stuk</strong></li>
              <li><span>Active buzzer (bonus)</span><strong>1 stuk</strong></li>
              <li><span>220Ω weerstanden</span><strong>resistor-pack</strong></li>
              <li><span>Jumper wires (M-M)</span><strong>set</strong></li>
              <li><span>Tutorial CD + handleiding</span><strong>inbegrepen</strong></li>
              <li><span>Begeleiding 3u + drankje/snack</span><strong>inbegrepen</strong></li>
            </ul>
            <div>
              <a href="#inschrijven" className="btn btn-primary">
                Schrijf in →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
